import { render, staticRenderFns } from "./RequestStatus.vue?vue&type=template&id=24c35d5d"
import script from "./RequestStatus.vue?vue&type=script&lang=js"
export * from "./RequestStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports